import { Car } from "./car"
import { TagUser } from "./tag"

export type UserModel = {
    active: boolean
    confirmed: boolean
    id: string
    firstName: string
    lastName: string
    email: string
    password: string
    phone: string
    street: string | null
    zip: string | null
    city: string | null
    country: string | null
    companyId: string | null
    companyName: string | null
    taxId: string | null
    vatId: string | null
    cardNumber: string | null
    cardExpiration: string | null
    paymentRequestId: string | null
    monthlyAllowance: number | null
    monthlySpent: number | null
	showHiddenLocation: boolean
    tenants: string
    tags: TagUser[] | null
    rfids: UserRfid[] | null
    cars: Car[] | null
}

export type UserRfid = {
    id?: string;
    rfid: string;
    userId?: string;
}

export enum UserClassProfile {
    Standard,
    Anonymous,
    Whitelist
}